import React from "react";

const CardContact = ({ photo, type, content }) => {
  return (
    <div className="cardContact_outside">
      <img src={photo} alt="" />
      <div className="card_contact_detials">
        <p className="blueTextColor">
          {type === "email"
            ? "Email ID"
            : type === "phone"
            ? "Phone Number (MOBILE)"
            : type === "landline"
            ? "Phone Number (Landline)"
            : "Address"}
        </p>
        {type !== "email" ? (
          <p>{content}</p>
        ) : (
          <a href={`mailto:${content}`}>{content}</a>
        )}
      </div>
    </div>
  );
};

export default CardContact;
